// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";

require("./TextInput.css");

function TextInput(Props) {
  var match = Props.value;
  var value = match !== undefined ? match : "";
  var match$1 = Props.type_;
  var type_ = match$1 !== undefined ? match$1 : "text";
  var match$2 = Props.onChange;
  var onChange = match$2 !== undefined ? match$2 : (function (_e) {
        return /* () */0;
      });
  var match$3 = Props.name;
  var name = match$3 !== undefined ? match$3 : "";
  var match$4 = Props.placeholder;
  var placeholder = match$4 !== undefined ? match$4 : "";
  return React.createElement("input", {
              className: "xuder-input-text",
              name: name,
              placeholder: placeholder,
              type: type_,
              value: value,
              onChange: onChange
            });
}

var make = TextInput;

export {
  make ,
  
}
/*  Not a pure module */
